const geoLocationMixin = {
    data() {
        return {
            maxCoordsDistance: 500,
            maxOkAccurancy: 20,
        }
    },
    methods: {
         fetchUserLocation (timeout = 15000) {
             return new Promise(function(resolve, reject) {
                 let options = {
                     enableHighAccuracy: true,
                     timeout: timeout,
                     maximumAge: 0
                 };
                 navigator.geolocation.getCurrentPosition(
                     function (position) {
                         console.log("Доступ разрешён.");
                         resolve(position)
                     },
                     function (error) {
                         if(error.code == 1) {
                             console.log(`В доступе отказано! error.code: ${error.code}`);
                         }
                         reject(error)
                     },
                     options
                 )
             })
         },
        async fetchW3WData(lat, lng) {
            try {
                let response = await what3words.api.convertTo3wa({lat: lat, lng: lng}, 'en')
                return response.words
            } catch (e) {
                return ''
            }
        },
    }
}

export default geoLocationMixin